'use strict';
var React = require('react');
import axios from 'axios';
var ReactRedux = require('react-redux');
var BaseComponent = require('../shared/base');
var EnumCoreModule = require('../../public/js/enum-core');
var AccountActions = require('../../redux/accountAction');
var CommonModule = require('../../public/js/common.js');
var FooterLayout = require('../layouts/footer').FooterLayoutComponent;
let client = require('../../../sdk/client');

class NonPrivateSignUpComponent extends BaseComponent {

    constructor(props) {
        super(props);
        console.log("props.matriz");
        console.log(props.matriz);
        console.log(props.matriz[0]);

        var clienteid;
        var billing_vendedorid;
        var billing_addressid;
        var billing_emailnotification;
        var shipping_vendedorid;
        var shipping_addressid;
        var shipping_emailnotification;

        if(props.matriz) {
            if(props.matriz[0]) {
                clienteid = props.matriz[0].ClienteId;
                billing_vendedorid = props.matriz[0].VendedorId;
                billing_addressid = props.matriz[0].DireccionFacturacionId;
                billing_emailnotification = props.matriz[0].EmailNotification;
                shipping_vendedorid = props.matriz[0].VendedorId;
                shipping_addressid = props.matriz[0].DireccionId;
                shipping_emailnotification = props.matriz[0].EmailNotification;
            }
        } else {
            clienteid = "150409";
            billing_vendedorid = "1574";
            billing_addressid = "252521";
            billing_emailnotification = "wdzib@bepensa.com";
            shipping_vendedorid = "1574";
            shipping_addressid = "47725";
            shipping_emailnotification = "wdzib@bepensa.com";
        }

        this.state = {
            username: '',
            firstName: '',
            lastName: '',
            password: '',
            confirmPassword: '',
            notificatonEmail: '',
            phoneNumber: '',
            regimenFiscal: '',
            razon_social: '',
            rfc: '',
            PostCode: '',
            shipping_name: '',            
            billing_name: '',            
            shipping_lastname: '',
            billing_lastname: '',
            shipping_address: '',
            shipping_suburb: '',
            shipping_street: '',
            shipping_extNumber: '',
            shipping_intNumber: '',
            shipping_latitude: '',
            shipping_longitude: '',
            billing_address: '',
            billing_suburb: '',
            billing_street: '',
            billing_extNumber: '',
            billing_intNumber: '',
            shipping_zip_code: '',
            billing_zip_code: '',
            shipping_city: '',
            billing_city: '',
            shipping_state: '',
            billing_state: '',
            vendedor_id: '',
            addressID: '',
            clienteid: clienteid,
            billing_vendedorid: billing_vendedorid,
            billing_addressid: billing_addressid,
            billing_emailnotification: billing_emailnotification,
            shipping_vendedorid: shipping_vendedorid,
            shipping_addressid: shipping_addressid,
            shipping_emailnotification: shipping_emailnotification,
            token: '',
            shippingStates: [],
            billingStates: [],
            shippingMunicipalities: [],
            billingMunicipalities: [],
            selectedState: '',
        };

        this.submitButton = React.createRef();
    }
    
    async onCreateAccount(e) {
        var self = this;

        let search = window.location.search;
        let params = new URLSearchParams(search);
        let token = params.get('token');
        let regimen_fiscal = this.state.regimenFiscal;
        let shipping_name = this.state.shipping_name;
        let billing_name = this.state.billing_name;
        let shipping_lastname = this.state.shipping_lastname;
        let billing_lastname = this.state.billing_lastname;
        let shipping_address = this.state.shipping_address;
        let billing_address = this.state.billing_address;
        let shipping_zip_code = this.state.shipping_zip_code;
        let billing_state = this.state.billing_state;
        let billing_city = this.state.billing_city;
        let billing_zip_code = this.state.billing_zip_code;
        //let shipping_city = this.state.shipping_city;
        //let shipping_state = this.state.shipping_state;
        //let vendedor_id = this.state.vendedor_id;
        //let addressID = this.state.addressID;

        $('[data-react-state-name]').removeClass('error-con')

        const sucursales = {
            "Chihuahua": 2807,
            "Zacatecas": 2933,
            "Coahuila": 2819,
            "Colima": 2729,
            "Jalisco": 2886,
            "Puebla": 2848,
            "Oaxaca": 2839,
            "Veracruz": 1992,
            "Sinaloa": 1852,
            "Sonora": 2702,
            "Chiapas": 2766,
            "Tabasco": 2766,
            "Yucatán": 2713,
            "Quintana Roo": 2859
        };

        let vendedorId = null;
        if (sucursales[self.state.shipping_state]) {
            vendedorId = sucursales[self.state.shipping_state];
        } else if (sucursales[self.state.shipping_city]) {
            vendedorId = sucursales[self.state.shipping_city];
        }

        self.setState({
            password: self.state.password.trim(),
            confirmPassword: self.state.confirmPassword.trim(),
            username: self.state.username.trim(),
            firstName: self.state.firstName.trim(),
            lastName: self.state.lastName.trim(),
            phoneNumber: self.state.phoneNumber.trim(),
            razon_social: self.state.razon_social.trim(),
            rfc: self.state.rfc.trim(),
            shipping_city: self.state.shipping_city,
            shipping_state: self.state.shipping_state,
            vendedor_id: vendedorId,
            addressID: self.state.addressID,   
            clienteid: self.state.clienteid,         
            shipping_name: self.state.shipping_name,
            shipping_lastname: self.state.shipping_lastname,
            shipping_address: `${self.state.shipping_suburb}, ${self.state.shipping_street}, ${self.state.shipping_extNumber}, ${self.state.shipping_intNumber}`,
            shipping_suburb: self.state.shipping_suburb,
            shipping_street: self.state.shipping_street,
            shipping_extNumber: self.state.shipping_extNumber,
            shipping_intNumber: self.state.shipping_intNumber,
            shipping_zip_code: self.state.shipping_zip_code,            
            billing_name: self.state.billing_name,
            billing_lastname: self.state.billing_lastname,
            billing_address: `${self.state.billing_suburb}, ${self.state.billing_street}, ${self.state.billing_extNumber}, ${self.state.billing_intNumber}`,
            billing_suburb: self.state.billing_suburb,
            billing_street: self.state.billing_street,
            billing_extNumber: self.state.billing_extNumber,
            billing_intNumber: self.state.billing_intNumber,
            billing_state: self.state.billing_state,
            billing_city: self.state.billing_city,
            billing_zip_code: self.state.billing_zip_code,
        }, async function () {

            var hasError = 0;
            var errPrompt = [];
            const emailPattern = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;

            const numberApi = self.state.shipping_extNumber !== "" ? self.state.shipping_extNumber : self.state.shipping_intNumber;
            const apiLatitudeAndLongitude = `https://api.copomex.com/query/info_cp_geocoding/${self.state.shipping_zip_code}?type=simplified&calle=${self.state.shipping_street}&numero=${numberApi}&token=${process.env.API_TOKEN_COPOMEX}`;

            try {
                const response = await axios.get(apiLatitudeAndLongitude);
                const latitudeApi = response.data.response.geocoding[0].lat;
                const longitudeApi = response.data.response.geocoding[0].long;
                
                self.setState({
                    shipping_latitude: latitudeApi,
                    shipping_longitude: longitudeApi,
                })
                    
            } catch (error) {
                console.error('Error al obtener latitud y longitud:', error);
            }

            if (self.state.password == '' || self.state.confirmPassword == '' || self.state.username == '') {
                $('.password, .confirm-password, .username').addClass('error-con')
                errPrompt.push(EnumCoreModule.GetToastStr().Error.USER_NAME_PASSWORD_REQUIRED);
                hasError = 1;
            }

            if (!emailPattern.test(self.state.username)) {
                $('.username').addClass('error-con');
                errPrompt.push(EnumCoreModule.GetToastStr().Error.EMAIL_NOT_MATCH);
                hasError = 1;
            }

            if (self.state.firstName == '') {
                $('.firstName').addClass('error-con')
                errPrompt.push(EnumCoreModule.GetToastStr().Error.FIRST_NAME_REQUIRED);
                hasError = 1;
            }

            if (self.state.lastName == '') {
                $('.lastName').addClass('error-con')
                errPrompt.push(EnumCoreModule.GetToastStr().Error.LAST_NAME_REQUIRED);
                hasError = 1;
            }

            if (self.state.phoneNumber == '') {
                $('.phone').addClass('error-con')
                errPrompt.push(EnumCoreModule.GetToastStr().Error.PHONE_REQUIRED);
                hasError = 1;
            } else {
                const phoneNumberPattern = /^[\d() -]+$/;
                if (!phoneNumberPattern.test(self.state.phoneNumber)) {
                    $('.phone').addClass('error-con');
                    errPrompt.push(EnumCoreModule.GetToastStr().Error.PHONE_NOT_MATCH);
                    hasError = 1;
                }
            }

            if (self.state.password == '' || self.state.confirmPassword == '') {
                $('.password, .confirm-password').addClass('error-con')
                errPrompt.push(EnumCoreModule.GetToastStr().Error.PLEASE_FILL_OUT_THE_REQUIRED_FIELD_TO_PROCEED);
                hasError = 1;
            }

            if (self.state.password != self.state.confirmPassword) {
                $('.password, .confirm-password').addClass('error-con')
                errPrompt.push(EnumCoreModule.GetToastStr().Error.PASSWORD_ERRORS.PASSWORD_CONFIRM_DOESNT_MATCH);
                hasError = 1;
            }


            if (self.state.password.length < 6) {
                $('.password, .confirm-password').addClass('error-con')
                errPrompt.push(EnumCoreModule.GetToastStr().Error.PASSWORD_ERRORS.PASSWORD_MUST_CONTAIN_SIX_CHARACTERS);
                hasError = 1;
            }

            if (hasError) {
                e.persist();
                this.showMessage(errPrompt[0]);
                return;
            }

            const sucursales = {
                "Chihuahua": 2807,
                //"Chihuahua": 2610,
                "Zacatecas": 2933,
                "Coahuila": 2819,
                "Colima": 2729,
                "Jalisco": 2886,
                "Puebla": 2848,
                "Oaxaca": 2839,
                "Veracruz": 1992,
                "Sinaloa": 1852,
                //"Sinaloa": 2563,
                "Sonora": 2702,
                //"Sonora": 1855,
                "Chiapas": 2766,
                "Tabasco": 2766,
                "Yucatán": 2713,
                "Quintana Roo": 2859
            };

            const idSucursales = {
                "Chihuahua": 281,
                "Zacatecas": 372,
                "Coahuila": 24,
                "Colima": 361,
                "Jalisco": 22,
                "Puebla": 357,
                "Oaxaca": 360,
                "Veracruz": 358,
                "Sinaloa": 194,
                "Sonora": 371,
                "Chiapas": 381,
                "Tabasco": 286,
                "Yucatán": 20,
                "Quintana Roo": 418
            };

            let vendedorId = null;
            if (sucursales[self.state.shipping_city]) {
                vendedorId = sucursales[self.state.shipping_city];
            } else if (sucursales[self.state.shipping_state]) {
                vendedorId = sucursales[self.state.shipping_state];
            }

            let address_id = null;
            if (idSucursales[self.state.shipping_city]) {
                address_id = idSucursales[self.state.shipping_city];
            } else if (idSucursales[self.state.shipping_state]) {
                address_id = idSucursales[self.state.shipping_state];
            }

            document.getElementById('vendedor_id').value = vendedorId;
            document.getElementById('addressID').value = address_id
            $('#token').val(token)
            var btn = document.getElementById('submitRegister');
            $('#submitRegister').prop('disabled', true);
            btn.innerText = 'Registrando...'

            var options = {
                firstName: self.state.firstName.trim(),
                lastName: self.state.lastName.trim(),
                username: self.state.username.trim(),
                password: self.state.password.trim(),
                confirmPassword: self.state.confirmPassword.trim(),
                email: self.state.username.trim(),
                token: null,
                IsSeller: false
            };

            client.Accounts.registerWithUsernameAndPassword(options, function(err, result) {
                console.log(result.UserId);
                var userId = result.UserId;

                var options2 = {
                    "DisplayName": self.state.firstName.trim() + " " + self.state.lastName.trim(),
                    "PhoneNumber": self.state.phoneNumber.trim(),
                    "Media": [
                        {
                            "ID": null,
                            "MediaUrl": "https://i.imgur.com/IioOqBl.jpeg"
                        }
                    ],
					"CustomFields": [
						{
                             "Code": process.env.CF_TIPO_USUARIO,
                            "Values": ["B2C"]
                        },
                        {
                            "Code": process.env.CF_RFC_EMPRESA,
                            "Values": [self.state.rfc.trim()]
                        },
                        {
                            "Code": process.env.CF_REGIMEN_FISCAL, 
                            "Values": [self.state.regimenFiscal]
                        },
                        {
                            "Code": process.env.CF_CLIENTE_ID, 
                            "Values": [self.state.clienteid]
                        },
                        {
                            "Code": process.env.CF_VENDEDOR_ID,
                            "Values": [vendedorId]
                        },
                        {
                            "Code": process.env.CF_CLIENTE_CONSULTA, 
                            "Values": ["NO"]
                        },
                        {
                            "Code": process.env.CF_EMPRESA,
                            "Values": [self.state.razon_social.trim()]
                        }
					]
				};

                client.Users.updateUser(userId, options2, function(err, result) {
                    console.log(result);

                    if($('a[aria-expanded="false"]').length == 0) {
                        var options3 = {
                            "Name":  self.state.shipping_name + " | " + self.state.shipping_lastname,
                            "Line1": `${self.state.shipping_suburb}, ${self.state.shipping_street}, ${self.state.shipping_extNumber}, ${self.state.shipping_intNumber}`,
                            "Line2": `${self.state.shipping_name} ${self.state.shipping_lastname} (Envío Default)`,
                            "PostCode": self.state.shipping_zip_code,
                            "Latitude": self.state.shipping_latitude,
                            "Longitude": self.state.shipping_longitude,
                            "Delivery": true,
                            "Pickup": true,
                            "SpecialInstructions": null,                                    
                            "State": self.state.shipping_state,
                            "City": self.state.shipping_city,
                            "Country": "Mexico",
                            "CountryCode": "MX",
                        }

                        client.Addresses.createAddress(userId, options3, function(err, result) {
                            var billingName;
                            var billingLastname;
                            var billingSburb;
                            var billingStreet;
                            var billingExtNumber;
                            var billingintNumber;
                            var billingZipCode;
                            var billingState;
                            var billingCity;

                            if ($('#isBillingSameAsShipping').is(':checked')) {         
                                billingName = self.state.shipping_name;
                                billingLastname = self.state.shipping_lastname;
                                billingSburb = self.state.shipping_suburb;
                                billingStreet = self.state.shipping_street;
                                billingExtNumber = self.state.shipping_extNumber;
                                billingintNumber = self.state.shipping_intNumber;
                                billingZipCode = self.state.shipping_zip_code;
                                billingState = self.state.shipping_state;
                                billingCity = self.state.shipping_city;
                            } else {
                                billingName = self.state.billing_name;
                                billingLastname = self.state.billing_lastname;
                                billingSburb = self.state.billing_suburb;
                                billingStreet = self.state.billing_street;
                                billingExtNumber = self.state.billing_extNumber;
                                billingintNumber = self.state.billing_intNumber;
                                billingZipCode = self.state.billing_zip_code;
                                billingState = self.state.billing_state;
                                billingCity = self.state.billing_city;
                            }
                            var options4 = {
                                "Name":  billingName + " | " + billingLastname,
                                "Line1": `${billingSburb}, ${billingStreet}, ${billingExtNumber}, ${billingintNumber}`,
                                "Line2": `${self.state.billing_name} ${self.state.billing_lastname} (Facturación)`,
                                "PostCode": billingZipCode,
                                "Latitude": null,
                                "Longitude": null,
                                "Delivery": true,
                                "Pickup": false,
                                "SpecialInstructions": null,                                    
                                "State": billingState,
                                "City": billingCity,
                                "Country": "Mexico",
                                "CountryCode": "MX",
                            }

                            client.Addresses.createAddress(userId, options4, function(err, result) {
                                var div = document.createElement('div');
                                div.setAttribute('style','display: none;')
                                div.innerHTML = `<form suppressHydrationWarning={true} key="custom-login" id="frmlogin" action="/accounts/non-private/sign-in" className="hide" method="post" autoComplete="off">
                                    <div className="lbb-input">
                                        <input type="hidden" id="returnUrl1" name="returnUrl1" defaultValue="" />
                                        <input type="hidden" id="isMerge1" name="isMerge1" defaultValue={isMerge} />
                                        <input type="text" className="input-text" placeholder="Correo/Usuario" id="username" name="username"/>
                                        <input type="password" className="input-text" placeholder="Contraseña" id="password" name="password" autoComplete="off" />
                                        <input type="isSeller" className="hidden" id="isSeller1" name="isSeller1"/>
                                    </div>
                                    <div className="btn-signin">
                                        <a href="#" onClick={(e) => self.loginWithUsernameAndPassword()}>Iniciar sesión</a>
                                    </div>
                                </form>`;

                                document.getElementsByClassName('row')[0].appendChild(div);

                                document.getElementById('username').value = $('input[name="username"]')[1].value.trim()
                                document.getElementById('password').value = $('input[name="password"]')[1].value.trim()
                                
                                $('#frmlogin').submit();
                            });
                        });
                    } else {
                        var div = document.createElement('div');
                        div.setAttribute('style','display: none;')
                        div.innerHTML = `<form suppressHydrationWarning={true} key="custom-login" id="frmlogin" action="/accounts/non-private/sign-in" className="hide" method="post" autoComplete="off">
                                    <div className="lbb-input">
                                        <input type="hidden" id="returnUrl1" name="returnUrl1" defaultValue="" />
                                        <input type="hidden" id="isMerge1" name="isMerge1" defaultValue={isMerge} />
                                        <input type="text" className="input-text" placeholder="Correo/Usuario" id="username" name="username1"/>
                                        <input type="password" className="input-text" placeholder="Contraseña" id="password" name="password1" autoComplete="off" />
                                        <input type="isSeller" className="hidden" id="isSeller1" name="isSeller1"/>
                                    </div>
                                    <div className="btn-signin">
                                        <a href="#" onClick={(e) => self.loginWithUsernameAndPassword()}>Iniciar sesión</a>
                                    </div>
                                </form>`;

                        document.getElementsByClassName('row')[0].appendChild(div);

                        document.getElementById('username').value = $('input[name="username"]').val().trim()
                        document.getElementById('password').value = $('input[name="password"]').val().trim()
                                
                        $('#frmlogin').submit();
                    }
                });
            });
        })
        e.preventDefault();
        return false;
    }

    handleRegimenFiscalChange(e) {
        this.setState({
            regimenFiscal: e.target.value
        });
    }

    fetchStates = async (addressType) => {
        try {
            const response = await axios.get(`https://api.copomex.com/query/get_estados?token=${process.env.API_TOKEN_COPOMEX}`);
            if (addressType === 'shipping') {
                this.setState({ shippingStates: response.data.response.estado });
            } else {
                this.setState({ billingStates: response.data.response.estado });
            }
        } catch (error) {
            console.error('Error fetching states:', error);
        }
    };

    fetchMunicipalities = async (stateName, addressType) => {
        try {
            const response = await axios.get(`https://api.copomex.com/query/get_municipio_por_estado/${stateName}?token=${process.env.API_TOKEN_COPOMEX}`);
            if (addressType === 'shipping') {
                this.setState({ shippingMunicipalities: response.data.response.municipios });
            } else {
                this.setState({ billingMunicipalities: response.data.response.municipios });
            }
        } catch (error) {
            console.error('Error fetching municipalities:', error);
        }
    };

    handleShippingState = (e) => {
        const newState = e.target.value;
        this.setState({ shipping_state: newState });
        this.fetchMunicipalities(newState, 'shipping');
    }

    handleBillingState = (e) => {
        const newState = e.target.value;
        this.setState({ billing_state: newState });
        this.fetchMunicipalities(newState, 'billing');
    };

    componentDidMount() {
        var self = this;

        $('.input-text').keypress(function (event) {
            var keycode = (event.keyCode ? event.keyCode : event.which);
            if (keycode == '13') {
                self.submitButton.current.click()
            }
        });

        if (this.props.error == 'invalid-signup') {
            this.showMessage(EnumCoreModule.GetToastStr().Error.INVALID_LOGIN_CREDENTIALS);
        }
        
        this.withAddresses();
        this.sameAddresses();
        this.fetchStates('shipping');
        this.fetchStates('billing');
        // this.onStateSelection();
    }

    sameAddresses(){        
        var self = this;
        let formFields = ['name','lastname','address','city','zip_code'];

        $("#isBillingSameAsShipping").on("change", function(){
            if(this.checked) {
                $( "#section-billing-data" ).hide();          
                $(formFields).each(function(_key, value) {
                    $('#billing_'+value).val($('#shipping_'+value).val());
                });          
                
                let state = $('#shipping_state option:selected').val();  
                $('#billing_state option:contains(' + state + ')').prop('selected', true);   
                $('#sameAddresses').val("true");   
            }else{
                $( "#section-billing-data" ).show();       
                $(formFields).each(function(_key, value) {
                    $('#billing_'+value).val('');
                });
                $('#sameAddresses').val("false");
            }
        });

        const sucursales = {
            "Chihuahua": 2807,
            "Zacatecas": 2933,
            "Coahuila": 2819,
            "Colima": 2729,
            "Jalisco": 2886,
            "Puebla": 2848,
            "Oaxaca": 2839,
            "Veracruz": 1992,
            "Sinaloa": 1852,
            "Sonora": 2702,
            "Chiapas": 2766,
            "Tabasco": 2766,
            "Yucatán": 2713,
            "Quintana Roo": 2859
        };

        let vendedorId = null;
        if (sucursales[self.state.shipping_state]) {
            vendedorId = sucursales[self.state.shipping_state];
        } else if (sucursales[self.state.shipping_city]) {
            vendedorId = sucursales[self.state.shipping_city];
        }

        $("#btnRegister").on("click", function() {
            var self = this;
            if ($('#isBillingSameAsShipping').is(':checked')){         
                $(formFields).each(function(_key, value) {
                    $('#billing_'+value).val($('#shipping_'+value).val());
                });
                $('#sameAddresses').val("true");   
                self.setState({
                    billing_addressid: self.state.shipping_addressid,
                    billing_vendedorid: vendedorId,
                    billing_emailnotification: self.state.shipping_emailnotification
                });
            }else{
                $( "#section-billing-data" ).show("fast");       
                $(formFields).each(function(_key, value) {
                    $('#billing_'+value).val('');
                });
                $('#sameAddresses').val("false");   
                self.setState({
                    billing_addressid: '',
                    billing_vendedorid: '',
                    billing_emailnotification: ''
                });
            }
        });
    }

    withAddresses(){
        $(".btn-add-facturacion").on("click", function() {            
            let withAddresses = $('#withAddresses').val();

            if(withAddresses == "false"){
                $('#withAddresses').val("true");   
                $(".btn-add-facturacion").text("Ya no deseo dar de alta mis datos de facturación");
            }else if(withAddresses == "true"){
                $('#withAddresses').val("false");   
                $(".btn-add-facturacion").text("¿Quieres agregar tus datos de facturación?");
            }
        });
    }

    onStateSelection(){
        var self = this;
        $("#shipping_state").on("change", function(){  
            let shipping_addressid = $(this).find(':selected').attr('data-addressid');
            let shipping_vendedorid = $(this).find(':selected').attr('data-vendedorid');
            let shipping_emailnotification = $(this).find(':selected').attr('data-emailnotification');
            self.setState({
                shipping_state: $(this).val(),
                shipping_addressid: shipping_addressid,
                shipping_vendedorid: shipping_vendedorid,
                shipping_emailnotification: shipping_emailnotification
            });
        });
        $("#billing_state").on("change", function(){
            let billing_addressid = $(this).find(':selected').attr('data-addressid');
            let billing_vendedorid = $(this).find(':selected').attr('data-vendedorid');
            let billing_emailnotification = $(this).find(':selected').attr('data-emailnotification');
            self.setState({
                billing_state: $(this).val(),
                billing_addressid: billing_addressid,
                billing_vendedorid: billing_vendedorid,
                billing_emailnotification: billing_emailnotification
            });
        });
    }

    /*---------------------------------------------------------------------
                                Options Functions
    ---------------------------------------------------------------------*/

    regimenFiscalOptions(){        
        let output = [
            '601 - General de Ley Personas Morales',        
            '603 - Personas Morales con Fines no Lucrativos',
            '605 - Sueldos y Salarios e Ingresos Asimilados a Salarios',
            '606 - Arrendamiento',
            '607 - Régimen de Enajenación o Adquisición de Bienes',
            '608 - Demás ingresos',
            '610 - Residentes en el Extranjero sin Establecimiento Permanente en México',
            '611 - Régimen de Ingresos por Dividendos (socios y accionistas)',
            '612 - Personas Físicas con Actividades Empresariales y Profesionales',
            '614 - Ingresos por intereses',
            '615 - Régimen de los ingresos por obtención de premios',
            '616 - Sin obligaciones fiscales',
            '620 - Sociedades Cooperativas de Producción que optan por diferir sus ingresos',
            '621 - Incorporación Fiscal',
            '622 - Actividades Agrícolas, Ganaderas, Silvícolas y Pesqueras',
            '623 - Opcional para Grupos de Sociedades',
            '624 - Coordinados',
            '625 - Régimen de las Actividades Empresariales con ingresos a través de Plataformas Tecnológicas',
            '626 - Régimen Simplificado de Confianza'
        ];

        return output;
    }

    /*---------------------------------------------------------------------
                                Action Functions
    ---------------------------------------------------------------------*/

    cancelRegister(){   
        window.location.href="/";
        return false;
    }

    /*---------------------------------------------------------------------
                            Visual Render Functions
    ---------------------------------------------------------------------*/

    hrComponent(){
        return(
            <div className="row">
                <div className="col-xs-12">
                    <hr className="hr-red" />
                </div>
            </div>
        );
    }

    renderBackModal(){
        const self = this;
        return(
            <div id="registerBack" className="modal fade" role="dialog">
                <div className="modal-dialog modal-md">
                    <div className="modal-content">
                        <div className="modal-body">
                            <h4 className="modal-title">Datos no guardados</h4>
                            <p>
                                Si sales de este apartado sin guardar tus datos, estos se perderán y tendrás que volver
                                a capturarlos eventualmente.
                            </p>
                            <p>
                                ¿Deseas continuar con el registro?
                            </p>
                        </div>
                        <div className="modal-footer text-center">                            
                            <button type="button" className="btn btn-register-cancel" onClick={(e) => self.cancelRegister(e)} >Regresar</button>
                            <button type="button" className="btn btn-register-continue" data-dismiss="modal">Continuar</button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    renderPersonalDataForm(){
        return(
            <div id="section-personal-data">
                <div className="row">
                    <div className="col-xs-12 col-md-6">
                        <div className="form-group mandatory-field">
                        <input type="hidden"  className="input-text token " placeholder="token" id="token" name="token" data-react-state-name="token" value={this.state.token} onChange={(e) => this.onChange(e)} />
                        <input type="hidden" name="vendedor_id" id="vendedor_id" data-react-state-name="vendedor_id" value="" />
                        <input type="hidden" name="addressID" id="addressID" data-react-state-name="addressID" value="" />
                        <input type="hidden" name="clienteid" id="clienteid" data-react-state-name="clienteid" value={this.state.clienteid} onChange={(e) => this.onChange(e)} />
                        <input type="hidden" name="shipping_vendedorid" id="shipping_vendedorid" data-react-state-name="shipping_vendedorid" value={this.state.shipping_vendedorid} onChange={(e) => this.onChange(e)} />
                        <input type="hidden" name="shipping_addressid" id="shipping_addressid" data-react-state-name="shipping_addressid" value={this.state.shipping_addressid} onChange={(e) => this.onChange(e)} />
                        <input type="hidden" name="shipping_emailnotification" id="shipping_emailnotification" data-react-state-name="shipping_emailnotification" value={this.state.shipping_emailnotification} onChange={(e) => this.onChange(e)} />
                        <input type="hidden" name="billing_vendedorid" id="billing_vendedorid" data-react-state-name="billing_vendedorid" value={this.state.billing_vendedorid} onChange={(e) => this.onChange(e)} />
                        <input type="hidden" name="billing_addressid" id="billing_addressid" data-react-state-name="billing_addressid" value={this.state.billing_addressid} onChange={(e) => this.onChange(e)} />
                        <input type="hidden" name="billing_emailnotification" id="billing_emailnotification" data-react-state-name="billing_emailnotification" value={this.state.billing_emailnotification} onChange={(e) => this.onChange(e)} />
                            <label>*</label>
                            <input type="text" className="form-control input-text firstName" id="firstName" name="firstName" placeholder="Nombre(s)" data-react-state-name="firstName" value={this.state.firstName} onChange={(e) => this.onChange(e)} />
                        </div>
                    </div>
                    <div className="col-xs-12 col-md-6">
                        <div className="form-group mandatory-field">
                            <label>*</label>
                            <input type="text" className="form-control input-text lastName" id="lastName" name="lastName" placeholder="Apellidos" data-react-state-name="lastName" value={this.state.lastName} onChange={(e) => this.onChange(e)}/>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-xs-12 col-md-6">
                        <div className="form-group mandatory-field">
                            <label>*</label>
                            <input type="email" className="form-control input-text username" id="name" name="username" placeholder="Correo electrónico" data-react-state-name="username" value={this.state.username} onKeyDown={(e) => this.avoidWhiteSpaceOnKeyDown(e)} onChange={(e) => this.onChange(e)}/>
                        </div>
                    </div>
                    <div className="col-xs-12 col-md-6">
                        <div className="form-group mandatory-field">
                            <label>*</label>
                            <input type="tel" className="form-control input-text phone" id="phone" name="phone" placeholder="Teléfono" data-react-state-name="phoneNumber" value={this.state.phoneNumber} onKeyDown={(e) => this.avoidWhiteSpaceOnKeyDown(e)} onChange={(e) => this.onChange(e)}/>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-xs-12 col-md-6">
                        <div className="form-group mandatory-field">
                            <label>*</label>
                            <input type="password" className="form-control input-text password" id="password" name="password" placeholder="Contraseña" data-react-state-name="password" value={this.state.password} onChange={(e) => this.onChange(e)}/>
                        </div>
                    </div>
                    <div className="col-xs-12 col-md-6">
                        <div className="form-group mandatory-field">
                            <label>*</label>
                            <input type="password" className="form-control input-text confirm-password" id="confirmpassword" name="cofirm_password" placeholder="Confirma tu contraseña" data-react-state-name="confirmPassword" value={this.state.confirmPassword} onChange={(e) => this.onChange(e)}/>
                            <input type="hidden" className="form-control input-text notification-email" placeholder="Notification Email" name="email" data-react-state-name="username" value={this.state.username} onKeyDown={(e) => this.avoidWhiteSpaceOnKeyDown(e)} onChange={(e) => this.onChange(e)} />
                            <input type="hidden" className="form-control input-text" placeholder="displayName" name="displayName" data-react-state-name="displayName" value={this.state.firstName} onKeyDown={(e) => this.avoidWhiteSpaceOnKeyDown(e)} onChange={(e) => this.onChange(e)} />
                        </div>
                    </div>
                </div>
            </div>            
        );
    }

    renderShippingBillingDataForm(){

        let regimenFiscalOptions = this.regimenFiscalOptions();
        // let states = this.props.uniqueWarehouses;
        // states = [...states].sort((a, b) =>
        //     a.Estado > b.Estado ? 1 : -1,
        // );
        return(            
            <div id="shipping-billing-data" className="collapse">                
                <div id="section-shipping-data">
                    <div className="row">
                        <div className="col-xs-12">
                            <h3>Datos de envío</h3>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xs-12 col-md-6">
                            <div className="form-group">
                                <input type="text" className="form-control shipping_name" id="shipping_name" name="shipping_name" placeholder="Nombre(s) de contacto" data-react-state-name="shipping_name" value={this.state.shipping_name} onChange={(e) => this.onChange(e)}/>
                            </div>
                        </div>
                        <div className="col-xs-12 col-md-6">
                            <div className="form-group">
                                <input type="text" className="form-control shipping_lastname" id="shipping_lastname" name="shipping_lastname" placeholder="Apellidos de contacto" data-react-state-name="shipping_lastname" value={this.state.shipping_lastname} onChange={(e) => this.onChange(e)}/>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xs-12 col-md-6">
                            <div className="form-group">
                                <input type="text" className="form-control shipping_suburb" id="shipping_suburb" name="shipping_suburb" placeholder="Colonia" data-react-state-name="shipping_suburb" value={this.state.shipping_suburb} onChange={(e) => this.onChange(e)}/>
                            </div>
                        </div>
                        <div className="col-xs-12 col-md-6">
                            <div className="form-group">
                                <input type="text" className="form-control shipping_street" id="shipping_street" name="shipping_street" placeholder="Calle" data-react-state-name="shipping_street" value={this.state.shipping_street} onChange={(e) => this.onChange(e)}/>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xs-12 col-md-6">
                            <div className="form-group">
                                <input type="text" className="form-control shipping_extNumber" id="shipping_extNumber" name="shipping_extNumber" placeholder="Número exterior" data-react-state-name="shipping_extNumber" value={this.state.shipping_extNumber} onChange={(e) => this.onChange(e)}/>
                            </div>
                        </div>
                        <div className="col-xs-12 col-md-6">
                            <div className="form-group">
                                <input type="text" className="form-control shipping_intNumber" id="shipping_intNumber" name="shipping_intNumber" placeholder="Número interior" data-react-state-name="shipping_intNumber" value={this.state.shipping_intNumber} onChange={(e) => this.onChange(e)}/>
                            </div>
                        </div>
                    </div>
                    <input type="hidden" className="form-control shipping_latitude" id="shipping_latitude" name="shipping_latitude" placeholder="Latitude" data-react-state-name="shipping_latitude" value={this.state.shipping_latitude} onChange={(e) => this.onChange(e)}/>
                    <input type="hidden" className="form-control shipping_longitude" id="shipping_longitude" name="shipping_longitude" placeholder="Longitud" data-react-state-name="shipping_longitude" value={this.state.shipping_longitude} onChange={(e) => this.onChange(e)}/>
                    <div className="row">
                        <div className="col-xs-12">
                            <div className="form-group">
                                <input type="hidden" className="form-control shipping_address" id="shipping_address" name="shipping_address" placeholder="Dirección" data-react-state-name="shipping_address" value={this.state.shipping_address} onChange={(e) => this.onChange(e)}/>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xs-12 col-md-4">
                            <div className="form-group">
                                <select className="form-control shipping_state" id="shipping_state" name="shipping_state" value={this.state.shipping_state} onChange={this.handleShippingState}>
                                    <option value="">Seleccione el estado</option>
                                        {this.state.shippingStates.map((state, index) => (
                                            <option key={index} value={state}>{state}</option>
                                        ))}
                                </select>
                            </div>
                        </div>
                        <div className="col-xs-12 col-md-4">
                            <div className="form-group">
                                <select type="text" className="form-control shipping_city" id="shipping_city" name="shipping_city" placeholder="Ciudad" data-react-state-name="shipping_city" value={this.state.shipping_city} onChange={(e) => this.onChange(e)}>
                                    <option value="">Seleccione el estado para mostrar ciudades</option>
                                        {this.state.shippingMunicipalities.map((municipality, index) => (
                                            <option key={index} value={municipality}>{municipality}</option>
                                        ))}
                                </select>
                            </div>
                        </div>
                        <div className="col-xs-12 col-md-4">
                            <div className="form-group">
                                <input type="text" className="form-control shipping_zip_code" id="shipping_zip_code" name="shipping_zip_code" placeholder="C.P." data-react-state-name="shipping_zip_code" onKeyDown={(e) => this.avoidWhiteSpaceOnKeyDown(e)} value={this.state.shipping_zip_code} onChange={(e) => this.onChange(e)}/>
                            </div>
                        </div>
                    </div>
                </div>     
                <div className="row">
                    <div className="col-xs-12">
                        <h3>Datos de facturación</h3>
                    </div>
                </div>
                <div className="row">
                    <div className="col-xs-12 col-md-6">
                        <div className="form-group mandatory-field">
                            <label>*</label>
                            <input type="text" className="form-control razon_social" id="razon_social" name="razon_social" placeholder="Razón Social" data-react-state-name="razon_social" value={this.state.razon_social} onChange={(e) => this.onChange(e)}/>
                        </div>
                    </div>
                    <div className="col-xs-12 col-md-6">
                        <div className="form-group mandatory-field">
                            <label>*</label>
                            <input type="text" className="form-control rfc" id="rfc" name="rfc" placeholder="RFC" data-react-state-name="rfc" onKeyDown={(e) => this.avoidWhiteSpaceOnKeyDown(e)} value={this.state.rfc} onChange={(e) => this.onChange(e)}/>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-xs-12">                                
                        <div className="form-group mandatory-field">    
                            <label>*</label>
                            <select className="form-control regimen_fiscal" id="regimen_fiscal" name="regimen_fiscal" onChange={(e) => this.handleRegimenFiscalChange(e)} value={this.state.regimenFiscal}>
                                <option disabled selected value=""> &nbsp; &nbsp;Régimen de incorporación fiscal </option>
                                {regimenFiscalOptions.map((regimenFiscalOption, index) => (
                                    <option key={index} value={regimenFiscalOption}>
                                        {regimenFiscalOption}
                                    </option>
                                ))}   
                            </select>
                        </div>
                    </div>
                </div>                 
                <div className="row">
                    <div className="col-xs-12 text-right">
                        <div className="checkbox">
                            <label><input id="isBillingSameAsShipping" name="isBillingSameAsShipping" type="checkbox" value="1"/>La dirección de facturación y de envío es la misma</label>
                        </div>
                    </div>
                </div>    
                <div id="section-billing-data">      
                    <div className="row">
                        <div className="col-xs-12">
                            <h4>Dirección de facturación</h4>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xs-12 col-md-6">
                            <div className="form-group">
                                <input type="text" className="form-control billing_name" id="billing_name" name="billing_name" placeholder="Nombre(s) de contacto" data-react-state-name="billing_name" value={this.state.billing_name} onChange={(e) => this.onChange(e)} />
                            </div>
                        </div>
                        <div className="col-xs-12 col-md-6">
                            <div className="form-group">
                                <input type="text" className="form-control billing_lastname" id="billing_lastname" name="billing_lastname" placeholder="Apellidos de contacto" data-react-state-name="billing_lastname" value={this.state.billing_lastname} onChange={(e) => this.onChange(e)} />
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xs-12 col-md-6">
                            <div className="form-group">
                                <input type="text" className="form-control billing_suburb" id="billing_suburb" name="billing_suburb" placeholder="Colonia" data-react-state-name="billing_suburb" value={this.state.billing_suburb} onChange={(e) => this.onChange(e)}/>
                            </div>
                        </div>
                        <div className="col-xs-12 col-md-6">
                            <div className="form-group">
                                <input type="text" className="form-control billing_street" id="billing_street" name="billing_street" placeholder="Calle" data-react-state-name="billing_street" value={this.state.billing_street} onChange={(e) => this.onChange(e)}/>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xs-12 col-md-6">
                            <div className="form-group">
                                <input type="text" className="form-control billing_extNumber" id="billing_extNumber" name="billing_extNumber" placeholder="Número exterior" data-react-state-name="billing_extNumber" value={this.state.billing_extNumber} onChange={(e) => this.onChange(e)}/>
                            </div>
                        </div>
                        <div className="col-xs-12 col-md-6">
                            <div className="form-group">
                                <input type="text" className="form-control billing_intNumber" id="billing_intNumber" name="billing_intNumber" placeholder="Número interior" data-react-state-name="billing_intNumber" value={this.state.billing_intNumber} onChange={(e) => this.onChange(e)}/>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xs-12">
                            <div className="form-group">
                                <input type="hidden" className="form-control billing_address" id="billing_address" name="billing_address" placeholder="Dirección" data-react-state-name="billing_address" value={this.state.billing_address} onChange={(e) => this.onChange(e)} />
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xs-12 col-md-4">
                            <div className="form-group">
                                <select className="form-control billing_state" id="billing_state" name="billing_state" value={this.state.billing_state} onChange={this.handleBillingState}>
                                    <option value="">Seleccione el estado</option>
                                        {this.state.billingStates.map((state, index) => (
                                            <option key={index} value={state}>{state}</option>
                                        ))}
                                </select>
                            </div>
                        </div>
                        <div className="col-xs-12 col-md-4">
                            <div className="form-group">
                                <select type="text" className="form-control billing_city" id="billing_city" name="billing_city" placeholder="Ciudad" data-react-state-name="billing_city" value={this.state.billing_city} onChange={(e) => this.onChange(e)}>
                                    <option value="">Seleccione el estado para mostrar ciudades</option>
                                        {this.state.billingMunicipalities.map((municipality, index) => (
                                            <option key={index} value={municipality}>{municipality}</option>
                                        ))}
                                </select>
                            </div>
                        </div>
                        <div className="col-xs-12 col-md-4">
                            <div className="form-group">
                                <input type="text" className="form-control billing_zip_code" id="billing_zip_code" name="billing_zip_code" placeholder="C.P." data-react-state-name="billing_zip_code" onKeyDown={(e) => this.avoidWhiteSpaceOnKeyDown(e)} value={this.state.billing_zip_code} onChange={(e) => this.onChange(e)} />
                            </div>
                        </div>
                    </div>       
                </div>
            </div>
        );
    }

    renderRegisterForm(){
        const self = this;
        // UrlAction cambiada por ahora
        let urlAction = "/accounts/non-private/sign-in";

        let isMerge = false;
        const returnUrl = '';

        return(
            <div className="container">
                <form key="custom-signup" id="frmlogin2" action="/accounts/non-private/signup" className="custom-login" method="post" autoComplete="off">
                    <div className="row">
                        <div className="col-xs-12">                            
                            {<img className='logo-register' src="/assets/images/bepensa/logo-megamak-hd.png"></img>}
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xs-12">
                            <h2 className='create-account-title'>Crear Cuenta</h2>
                            <p className="text-right"><b className="text-color-red">*</b> Campos Obligatorios</p>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-xs-12">
                            <div className="panel-group" id="accordion">

                                { this.renderPersonalDataForm() }

                                { this.renderShippingBillingDataForm() }

                                { this.renderBackModal() }

                            </div>

                        </div>
                    </div>

                    <div className="row">                        
                        <div className="col-xs-12">
                            <input id="withAddresses" type="hidden" value="false" />
                            <input id="sameAddresses" type="hidden" value="false" />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xs-12 col-md-6">
                            <a href="#shipping-billing-data" data-toggle="collapse" className="btn btn-link btn-add-facturacion">
                                ¿Quieres agregar tus datos de facturación?
                            </a>
                        </div>
                        <div className="col-xs-12 col-md-6 text-right">                            
                            <button type="button" className="btn btn-register-back hidden-xs" data-toggle="modal" data-target="#registerBack">Regresar</button>    
                            <button id="submitRegister" className="btn btn-register" href="#" ref={self.submitButton} onClick={(e) => self.onCreateAccount(e)}>Registrarse</button>                          
                            <button type="button" className="btn btn-register-back visible-xs" data-toggle="modal" data-target="#registerBack">Regresar</button>       
                        </div>
                    </div>

                </form>
            </div>
        );
    }

    render() {
        var self = this;

        let urlAction = "/accounts/non-private/sign-in";

        return (
            <React.Fragment key="login-component">
                
                <div id="login-page">
                    <div className='register-page'>
                        { this.renderRegisterForm() }
                    </div>
                    <div className="footer fixed" id="footer-section">
                        <FooterLayout panels={this.props.panels} />
                    </div>
                </div> 


            </React.Fragment>
        );
    }
}

function mapStateToProps(state, ownProps) {
    return {
        type: state.type,
        host: state.type,
        googleLoginUrl: state.googleLoginUrl,
        facebookLoginUrl: state.facebookLoginUrl,
        marketplaceLogoUrl: state.marketplaceLogoUrl,
        marketplaceInfo :state.marketplaceInfo,
        error: state.error,
        isSeller: state.isSeller,
        warehouses: state.warehouses,
        uniqueWarehouses: state.uniqueWarehouses,
        matriz: state.matriz
    }
}

function mapDispatchToProps(dispatch) {
    return {
        createB2cClient: (options, callback) => dispatch(AccountActions.createB2cClient(options, callback))
    }
}

const NonPrivateSignUpReduxConnect = ReactRedux.connect(
    mapStateToProps,
    mapDispatchToProps
)(NonPrivateSignUpComponent)

module.exports = {
    NonPrivateSignUpReduxConnect,
    NonPrivateSignUpComponent
}